import { apiService } from "../../app.service";

export const teamApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch a team member
    fetchTeamMember: builder.query({
      query: (id) => ({
        url: `/user/members/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "member", id: result._id }] : [],
    }),

    // Fetch all team member
    fetchTeamMembers: builder.query({
      query: () => ({
        url: "/user/members",
      }),
      providesTags: ["members"],
    }),

    // Create a new team member
    createTeamMember: builder.mutation({
      query: (data) => ({
        url: "/user/members",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["members"],
    }),

    // Update an existing team member
    updateTeamMember: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/members/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "member", id },
        "members",
      ],
    }),

    // Delete a team member
    deleteTeamMember: builder.mutation({
      query: (id) => ({
        url: `/user/members/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["members"],
    }),
  }),
});

export const {
  useFetchTeamMemberQuery,
  useFetchTeamMembersQuery,
  useCreateTeamMemberMutation,
  useUpdateTeamMemberMutation,
  useDeleteTeamMemberMutation,
} = teamApi;
